/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */




(function($) {

  var body = $("html, body");

    function igualaAlturas(_itm){

       
        var altMax=0;  
        $(_itm).css('height','initial');
        $(_itm).each(function(){ 
              altMax=Math.max(altMax, $(this).height());  

        }); 

 
       $(_itm).height(altMax);    
  }

  function arreglosAlturas(){
    console.log("ARREGLO H");
    igualaAlturas($('.item_equipo .eq_bio'));
    igualaAlturas($('.item_equipo .eq_nombre'));
    //
    igualaAlturas($('.item_new'));
    //
    igualaAlturas($('.item_link .desc_link'));
    igualaAlturas($('.item_link .eq_nombre')); 

  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {


      //NICESCROLL

       $("html").niceScroll({cursorwidth :"10px"});

        //MENU IDIOMAS

       // $('.sociales ul').append('<li>'+$('.list_idiomas').html()+'</li>' );
       // $('.list_idiomas').css('display','block') ;


        // JavaScript to be fired on all pages 


        arreglosAlturas();
    

         var bannerTop = new Swiper('.banner-swiper', { 
                 autoplay: 5000,
                 autoplayDisableOnInteraction:false, 
                 speed:500,
                  effect: 'fade',
                 fade: { crossFade: true },
                 loop:true
 
            });
 
         var emailForm = false;
         var nameForm =false;

        $('.mc-field-group input[type="text"]').focusin(function() {
          if(!nameForm){
            $(this).attr("value","");
            nameForm=true;
          }
          
        });
         $('.mc-field-group input[type="email"]').focusin(function() {
          if(!emailForm){
            $(this).attr("value","");
            emailForm=true;
          }
          
        });


/*

         //FORMULARIO CONTACTO

         var nomContacto=false;
         var comentContacto=false;
         var emailContacto=false;
         var titulacionContacto=false;

        $('.form_contacto input[name="nombre"]').focusin(function() {
          if(!nomContacto){
            $(this).attr("value","");
            nomContacto=true;
          }
          
        });
         $('.form_contacto input[name="email"]').focusin(function() {
          if(!emailContacto){
            $(this).attr("value","");
            emailContacto=true;
          }
          });
        $('.form_contacto textarea').focusin(function() {
          if(!comentContacto){
            $(this).attr("value","");
            comentContacto=true;
          }
          
        });
 



         //FORMULARIO TALLER

         var nomTaller=false;
         var dniTaller=false;
         var emailTaller=false;
         var titulacionTaller=false;

        $('.form_taller input[name="nombre"]').focusin(function() {
          if(!nomTaller){
            $(this).attr("value","");
            nomTaller=true;
          }
          
        });
         $('.form_taller input[name="email"]').focusin(function() {
          if(!emailTaller){
            $(this).attr("value","");
            emailTaller=true;
          }
          });
        $('.form_taller input[name="dni"]').focusin(function() {
          if(!dniTaller){
            $(this).attr("value","");
            dniTaller=true;
          }
          
        });
         $('.form_taller input[name="titulacion"]').focusin(function() {
          if(!titulacionTaller){
            $(this).attr("value","");
            titulacionTaller=true;
          }
          
        });

*/

         //JS FORMULARIO

       

         var arrFormulario = new Array() ;
         var itemsForm = new Array();


         $('.formulario textarea').attr('rows', 7);

         $('#call-for-papers .formulario .itm_form').each(function(i){

            var itemFormu = $(this).find('input').attr('value');

            if(!itemFormu){
              itemFormu = $(this).find('textarea').attr('value');
            }

            arrFormulario.push(itemFormu);
            itemsForm.push(false);




           $(this).data('inicial', itemFormu);


            if( $(this).find('input').length!=0  ){

               
////

                            $(this).find('input').focusin(function(){ 
 


                                     console.log($(this).val()+" == " +$(this).parents('.itm_form').data('inicial') );

               

                                if( $(this).val() == $(this).parents('.itm_form').data('inicial')  ){

                                    $(this).val("");
                                }

         

                          });



                          $(this).find('input').focusout(function(){  


                                     console.log("OUTPUT " + $(this).val()+" == " +$(this).parents('.itm_form').data('inicial') );

               

                                if( $(this).val() === ""  ){

                                    $(this).val(  $(this).parents('.itm_form').data('inicial')    );
                                }

         

                          });



/////
        


                    }


                    if( $(this).find('textarea').length!=0 ){


                           // $(this).find('textarea').css('border', '2px solid red');

                            console.log(">>> "+itemFormu+" > "+$(this).attr('class') +" "+  $(this).find('textarea').length +" //// " + $(this).data('inicial')  );


                            $(this).data('inicial', itemFormu); 
/////

                            $(this).find('textarea').focusin(function(){ 
 


                                     console.log($(this).val()+" == " +$(this).parents('.itm_form').data('inicial') );

               

                                if( $(this).val() == $(this).parents('.itm_form').data('inicial')  ){

                                    $(this).val("");
                                }

         

                          });



                          $(this).find('textarea').focusout(function(){  


                                     console.log("OUTPUT " + $(this).val()+" == " +$(this).parents('.itm_form').data('inicial') );

               

                                if( $(this).val() === ""  ){

                                    $(this).val(  $(this).parents('.itm_form').data('inicial')    );
                                }

         

                          });


////

                    }


         });

          

         



         $('.banner_principal').css('margin-top',$('header').height());


      /*   $('.alt_out').each(function(){
            $(this).height( $(this).parent().innerHeight() );
         });*/

        
        $('.navbar-nav a').on("click", function(){

          var goTo = $(this).attr('href');

          var secDesp = 0; 

          if($(goTo).find('.separata').length ===0 ){

            secDesp = parseInt($(goTo).find('.seccion_cont').css('margin-top'));


            if(!secDesp){
              secDesp = 0;
            }

          }

          goTo = $(goTo).offset().top - ( $('header').outerHeight(true)  -  20    ) +secDesp; //parseInt($('.seccion').css('margin-bottom'))

          body.stop().animate({scrollTop:goTo}, '500', 'swing', function() { 
            
          });


        })

      console.debug(navigator.userAgent);
  
  if (navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1) {

    

        if((navigator.userAgent.indexOf('iPad')===-1) &&  (navigator.userAgent.indexOf('iPhone')===-1)   ){
            console.debug("SAFARI!");
           // $('.sociales .entry-share').css('margin-top',0);
           // $('.list_idiomas').css('margin-top',0);
            $('.parte_menu').css('margin-top','-20px');
        }

      
    }else{
          console.debug("NO SAFARI!");
    }





    //SCROLLMAGÇIC:

      //Creo el controlador
      var controller = new ScrollMagic.Controller(); 

 

      /*
<div class="back_separata pos_rel">
  <div class="separata back_img_separata" style="background-image:url('<?php echo $imgBanner ?>')"> 
      */

var animeSeparatas =new Array();
var animeAlts = new Array();
var animeTriggers = new Array();

$('.back_separata').each(function(i){

    var inBack = $(this).find('.back_img_separata');

   

    var tweenBack=TweenMax.fromTo( inBack ,1,{
    backgroundPosition:"center 50%", 
    opacity:1 },
    {backgroundPosition:"center 100%",
    ease:Linear.easeNone, 
    opacity:1  }) ;

    var sepID = $(this).attr('id');
    sepID = "#"+sepID;

    animeSeparatas.push(tweenBack);
    animeTriggers.push(sepID);
    animeAlts.push( $(this).height()  );
    h = $(window).height() ;
    console.log(sepID+" > "+ $(this).offset().top+" / BODY "+$(body).height() + " WINDOW HEIGHT "+ h);

    var altBody = $(body).height();
    var dif =  altBody - ($(this).offset().top + h);

    if(dif<0){
      h = altBody - $(this).offset().top  ;
    }

    console.log("DIF "+ dif + " H "+h);


    var sceneTemp = new ScrollMagic.Scene({triggerElement: animeTriggers[i] , duration: h /*animeAlts[i]*/  }) 
            // añado el indicador visual
           // .addIndicators({name: sepID })  
            //Añado animaciones que se desarrollan
            .setTween([animeSeparatas[i] ])
            //Añado la escena al controlador
            .addTo(controller);


            var triggerHook = sceneTemp.triggerHook();
          //  sceneTemp.triggerHook("onLeave");
           sceneTemp.triggerHook(0.97);
 

  });


  //SWIPER BANNER


         var swiperFrases = new Swiper('.frases-swiper', { 
                 autoplay: 5000,
                 autoplayDisableOnInteraction:false, 
                 speed:2000, 
                 loop:true,
                 pagination:".swiper-pagination",
                 paginationClickable:true
 
            });






  /*
  Creamos 2 animaciones TweenMax.fromTo para realizar el fundido dede las 2 imágenes. 
  La primera sobre .over_seccion_3 en la que moveremos el backgroundPosition desde "center 0"
  y una opacity 1 hasta center  -50px y una opacity 0


  La segunda animación sobre .seccion_3 animaremos el backgroundPosiiton desde center 0 hasta center -50px
 


  var tweenBack=TweenMax.fromTo(".over_seccion_3",1,{
    backgroundPosition:"center 0", 
    opacity:1 },
    {backgroundPosition:"center -50px",
    ease:Linear.easeNone, 
    opacity:0  }) ;

  var tweenBack_2=TweenMax.fromTo(".seccion_3",1,{
    backgroundPosition:"center 0"},
    {backgroundPosition:"center -50px",
    ease:Linear.easeNone}) ;
 */
  /*
  Creamos la scene de las frases que se dispara desde #seccion-3 y dura $('#seccion-3').height() 



  var scene3 = new ScrollMagic.Scene({triggerElement: "#seccion-3", duration: $('#seccion-3').height()   }) 
          // añado el indicador visual
          .addIndicators({name: "Sec 3  "})  
          //Añado animaciones que se desarrollan
          .setTween([tweenBack, tweenBack_2])
          //Añado la escena al controlador
          .addTo(controller);   

  */



      //**** NOTICIAS AJAX ****

          var homeURL = $('body').data('home');
          //alert("HOME URL " + homeURL);


          $(".wp-pagenavi").each(function(){ 

              //CONSTRUYO EL LINK DE LA PAGINA 1

              var linkOne='<a class="page larger linkone" href="'+homeURL+'">'+$(this).find('.current').text()+'</a>';  
              $(this).find('span.current').after(linkOne);
              $(this).find('span.current').remove();

        });


        if($('body').hasClass('single')){ 

          $('.carga_post').addClass('noti_abierta');

          $(".wp-pagenavi a").each(function(){  
          
            $(this).attr('href', homeURL+"/page/"+$(this).text() );

          });





        }



        $.ajaxSetup({cache:false});


        $(".wp-pagenavi a.page, .wp-pagenavi a.last").click(function(ev){
          $('.currentwp').removeClass('currentwp');
            ev.preventDefault(); 

            if(  $('.carga_post').hasClass('noti_abierta')  ){


                       jQuery('.post_expanded').slideUp('normal', function(){ 

                                  jQuery('.carga_post').removeClass('noti_abierta'); 

                        });



            }

           

            //BUSCO DEL BOTÓN DE LA PÁGINA CLICKED AL CONTENEDOR DEL LISTADO QUE ES SU HERMANO 

            //var dataTerm=$(this).parent().siblings('.ajax_container').data("term");
            //var dataTax=$(this).parent().siblings('.ajax_container').data("tax"); 

            //ENLAZO LA TAXONOMÏA Y EL TERM

            var direVoy=$(this).attr("href");            
            
            //Si estoy en la página como resultado de una búsqueda cuando añado la taxonomía 
            //y el term lo haré con "ampresand" si no, es decir no hay búsqueda es cuando
            //añado el "?" 

           /* var post_link;

            if(direVoy.indexOf("?")!==-1){
                post_link = $(this).attr("href")+"&tax="+dataTax+"&miTermSlug="+dataTerm;
            }else{
                post_link = $(this).attr("href")+"?tax="+dataTax+"&miTermSlug="+dataTerm;
            }*/


            //alert(post_link + " #contenidoAjax-"+dataTerm );
            
           // $(this).parent().siblings('.ajax_container').css('border','5px solid green');
            //$(this).parent().siblings('.ajax_container').css("display",'none');

           // $('#contenidoAjax').html("Loading Content...");

           $('.carga_noticias').append('<div id="carga_load" class="cargando"  ></div>');    




            //CARGO EL CONTENIDO DE LA CAPA #contenidoAjax

            //$("#contenidoAjax-"+dataTerm).remove(); 

           // alert($(this).parent().siblings('.ajax_container').attr('class'));
 
           /* $(this).parent().siblings('.ajax_container').load(post_link + " #contenidoAjax-"+dataTerm , function(){   
               
            });  */


            var post_link = $(this).attr("href");

            var sec = "#"+ $(this).parents('.seccion').attr('id')  ;

            var linkSec = 'a[href="' + sec +'"]' ; 

            $(linkSec).trigger( "click" );

             

            $('.ajax_container').load(post_link+ " #contenidoAjax" , function(){  

                $('.carga_noticias').html($('.ajax_container').html());

                
                var notiTemp = setTimeout(igual, 500);
                function igual(){
                  clearTimeout(notiTemp);
                  igualaAlturas($('.item_new'));

                }
                

               
            });   

           // alert("MISSION 2 "+post_link+ " #contenidoAjax");
           // $(this).addClass('currentwp');

        return false;
        });

 //PAGE NAVI AJAX


      //**** NOTICIAS AJAX ****


      window.onload=function(){
        arreglosAlturas();
      }


      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired

      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function() {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');


      jQuery(window).resize(function(){

       arreglosAlturas();

      });


    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


